import React from 'react';
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  IconButton,
  Box,
  Typography,
  TablePagination,
  TextField,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';

export default function AgentRecentOrdersTable({ orders = [], onView, onTrack }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearch] = React.useState('');

  const filtered = orders.filter((o) => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (
      String(o.id).toLowerCase().includes(s) ||
      String(o.status || '').toLowerCase().includes(s) ||
      String(o.acceptedDate || '').toLowerCase().includes(s)
    );
  });

  return (
    <Paper sx={{ p: 2, borderRadius: 2, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', mt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6">Recent Orders</Typography>
        <TextField size="small" placeholder="Search orders" value={search} onChange={(e) => setSearch(e.target.value)} />
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Order ID</TableCell>
            <TableCell>Order Value</TableCell>
            <TableCell>Commission</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Accepted Date</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((o) => (
            <TableRow key={o.id} hover>
              <TableCell>{o.id}</TableCell>
              <TableCell>{o.value}</TableCell>
              <TableCell>{o.commission}</TableCell>
              <TableCell>
                <Chip label={o.status} color={o.status === 'Available' ? 'info' : o.status === 'Completed' ? 'success' : 'default'} size="small" />
              </TableCell>
              <TableCell>{o.acceptedDate || '-'}</TableCell>
              <TableCell>
                <IconButton size="small" color="primary" onClick={() => onView && onView(o)}>
                  <VisibilityIcon />
                </IconButton>
                <IconButton size="small" onClick={() => onTrack && onTrack(o)}>
                  <TrackChangesIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={filtered.length}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
      />
    </Paper>
  );
}
